const BASE_URL = "https://clock.poc.mrc.ai/api";

export async function getClocks() {
  const response = await fetch(`${BASE_URL}/clocks`);
  if (!response.ok) throw new Error("Failed to fetch Clocks");
  return await response.json();
}

export async function getClock(clockId) {
  const response = await fetch(`${BASE_URL}/clocks/${clockId}`);
  if (!response.ok) throw new Error("Failed to fetch Clock");
  return await response.json();
}

